import {
  AtlasBodyMain,
  AtlasCaption,
  BottomGroupMolecule,
  CardComponent,
  PageContentAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'

import { Icon } from '@justomx/atlas-icons'
import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { InputDialogOrganism } from 'components/organisms/InputDialog.organism'
import { useScanLocation } from './ScanLocation.hook'

const ScanLocationPage = () => {
  const { actions, container, dialogRef, loading } = useScanLocation()

  return (
    <>
      {loading && <LoaderAtom>Cargando...</LoaderAtom>}

      <ToolbarMolecule
        title="Escanea"
        actionIcon="close"
        onAction={actions.onGoBack}
        secondaryActionIcon="ic_keyboard"
        onSecondaryAction={actions.openKeyboard}
      />

      <PageContentAtom style={{ paddingTop: '70px' }}>
        <ScannerMolecule
          label="Ubicación de armado"
          gap={12}
          onScan={actions.handleScanLocation}
        />

        {container && (
          <BottomGroupMolecule bgColor="#212121">
            <CardComponent $variant="highlight">
              <StackAtom $direction="column" $gap={8}>
                <AtlasCaption>Tarima escaneada</AtlasCaption>

                <StackAtom $gap={4} $align="center">
                  <Icon name="ic_pallet" size={18} color="white" />
                  <AtlasBodyMain style={{ fontWeight: 700 }}>
                    {container}
                  </AtlasBodyMain>
                </StackAtom>
              </StackAtom>
            </CardComponent>
          </BottomGroupMolecule>
        )}

        <InputDialogOrganism
          dialogRef={dialogRef}
          title="Ubicación"
          textboxLabel="Escribe la ubicación"
          confirmLabel="Continuar"
          cancelLabel="Cancelar"
          confirmAction={actions.handleScanLocation}
        />
      </PageContentAtom>
    </>
  )
}

export default ScanLocationPage
